import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

const PCBQuotationRemark = (props) => {
    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-remark"
                                          defaultMessage="Remark"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <link id="pcbRemarks-qLink" to="/help/remarkHelp"
                              className="glyphicon glyphicon-question-sign question-link"></link>
                    </div>
                    <div className="pcb-quantity pcb-quantity-mobile ">
                    <div className="btn-group col-md-9 pcb-details-div-items">
                        <textarea onChange={props.setRemarks}
                                  className="pcb-remarks-text-area"
                                  value={props.remarks}/>
                    </div>
                    </div>
                    <div className="col-md-1">

                    </div>
                </div>
            </div>
        </div>
    )
};

export default PCBQuotationRemark;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PCBQuotationRemark.js